module.exports = __webpack_public_path__ + "img/op_five_steps_1_ex.a457d880.png";